module.exports = __webpack_public_path__ + "static/media/Virgen_Coromoto_small.1dcd94e2.jpg";